import { render, staticRenderFns } from "./InsightConversations.vue?vue&type=template&id=31b9c9f2&scoped=true&"
import script from "./InsightConversations.vue?vue&type=script&lang=js&"
export * from "./InsightConversations.vue?vue&type=script&lang=js&"
import style0 from "./InsightConversations.vue?vue&type=style&index=0&id=31b9c9f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b9c9f2",
  null
  
)

export default component.exports